import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=53858a56&scoped=true&lang=pug&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=53858a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53858a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53858a56')) {
      api.createRecord('53858a56', component.options)
    } else {
      api.reload('53858a56', component.options)
    }
    module.hot.accept("./withdraw.vue?vue&type=template&id=53858a56&scoped=true&lang=pug&", function () {
      api.rerender('53858a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/dialog/withdraw.vue"
export default component.exports